module.exports = __webpack_public_path__ + "img/cart-white-bg.b0cb18b9.jpg";